import * as _4 from 'lodash4';
export class StudentValueModel {
  private values: Record<string, string> = {};

  getValueByKey(key: string, defaultValue = null) {
    if (_4.has(this.values, key)) {
      return this.values[key];
    }

    return defaultValue;
  }
  getBooleanValueByKey(key: string) {
    return _4.has(this.values, key) && this.values[key].trim().toLowerCase() === 'true';
  }

  keys() {
    return _4.keys(this.values);
  }

  removeKey(key: string) {
    if (_4.has(this.values, key)) {
      delete this.values[key];
    }
  }

  update(newValues: {}) {
    this.values = newValues;
  }
}

angular.module('capability-ng-academic-planner').service('ngStudentValueModel', StudentValueModel);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/student_value/model/student_value_model.ts